export default __webpack_public_path__ + "static/media/person_3.7f21d46a.png";